<div class="page-bg">
  <div class="container pb-2 pt-2">
    <ng-container *ngIf="services.advService.bannersEnabled">
      <div class="adsContainer" *ngIf="!isPremium || !services.enableSubscription">
        <app-banner-zone-map [zoneType]="['Desktop-Zone-Horizontal-Top', 'Desktop-Zone-Horizontal-Bottom']" ></app-banner-zone-map>
      </div>
    </ng-container>
    <form [formGroup]="advForm"
          novalidate
          (ngSubmit)="onSubmit()"
          #form
          [uploadInputFor]="This">
      <mat-card class="adv-card p-0">
        <div class="row m-0 p-0 w-100">

          <div class="col-md-12">
            <div class="row">
              <div class="col-md-2" [ngClass]="{'col-md-2': !SpecialUser && !isThirdPartyAd, 'col-md-10': SpecialUser || isThirdPartyAd}">
                <h4 class="d-inline-block m-0">
                  <span *ngIf="isNew()">Add new </span>
                  <span *ngIf="!isNew()">Edit </span>
                  <span *ngIf="isPremiumAd || SpecialUser">Premium Verified </span> 
                  <span *ngIf="isThirdPartyAd">Third Party </span>
                  <span *ngIf="Expired">Expired </span>
                  <span>Ad</span>
                </h4>
              </div>
              <div class="col-md-8" *ngIf="!SpecialUser || isThirdPartyAd" [ngClass]="{'d-block': isThirdPartyAd}">
                <mat-radio-group (change)="changeAdType($event)">
                  <mat-radio-button class="inline-radio mr-4" [disabled]="(!isNew() && adv != null && adv.isPremium)" [checked]="AdType == 0" [value]="0" *ngIf="!isThirdPartyAd">Free</mat-radio-button>
                  <mat-radio-button class="inline-radio" [checked]="AdType == 1" [value]="1" *ngIf="!isThirdPartyAd">
                    Premium Verified Ad - shows on top of results, emojis, unlimited pictures 
                    <span style="color: #ff4081" *ngIf="UserPremiumAdToken > 0">({{UserPremiumAdToken }} Credit Left)</span>
                  </mat-radio-button>
                  <mat-radio-button class="inline-radio" [checked]="isThirdPartyAd" [value]="2" *ngIf="isThirdPartyAd && HasUserThirdPartyAdToken">
                    Third party Ad - <span style="color: #ff4081">({{UserThirdPartyAdToken }} Credit Left)</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
              <div class="col-md-2">
                <button *ngIf="!isNew()"
                        type="button"
                        (click)="tryDeleteAd()"
                        class="mat-button float-right p-0 del-hv">
                  <span>Delete Ad</span>
                  <mat-icon class="posicon">delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </mat-card>

      <div class="row m-0" *ngIf="AdView == 1 && !Expired">
        <div class="col-md-5">
          <premium-ad-token-payment #adTokenPaymentForm [payButtonText]="'Pay $1.99 for Premium Ad Now'" (onTokenAdded)="onTokenAdded($event)"  *ngIf="!isThirdPartyAd"></premium-ad-token-payment>
            <premium-ad-token-payment #adTokenPaymentForm [payButtonText]="'Pay $99 for Third Party Ad Now'" (onTokenAdded)="onTokenAdded($event, true)" [paymentFormType]="2" *ngIf="isThirdPartyAd"></premium-ad-token-payment>
        </div>
      </div>

      <div class="row m-0" *ngIf="AdView == 0 || Expired">
        <div class="col-lg-8 col-md-12 p-0 pb-3 border-sep-right">
          <mat-card class="p-0">
            <mat-card-content>
              <div class="row m-0">
                <div class="col-md-3 pl-0">


                  <mat-radio-group aria-label="Select an option"
                                   formControlName="casualDating"
                                   class="row flex-column m-0">
                    <mat-radio-button value="true" class="col-md-6 col-sm-12">Casual Dating</mat-radio-button>
                    <mat-radio-button value="false" class="col-md-6 col-sm-12">Long Term Relationships</mat-radio-button>
                  </mat-radio-group>
                </div>
                <div class="d-flex col-md-4 pr-0 pt-2">
                  <mat-form-field class="full-width" *ngIf="!isThirdPartyAd">
                    <mat-select placeholder="Who you are" [(value)]="selectedPersonType" formControlName="selectedPersonType" required="true">
                      <mat-option *ngFor="let personType of personTypes" [value]="personType.value">{{ personType.text }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="d-flex col-md-5 pt-2">
                  <mat-form-field class="full-width" [hidden]="!advForm.controls.selectedPersonType.value" *ngIf="!isThirdPartyAd">
                    <mat-select placeholder="Relationship"
                                formControlName="relationShips"
                                required="true">
                      <mat-option (click)="advForm.controls.relationShips.reset()"></mat-option>
                      <mat-option *ngFor="let sg of filteredCategories"
                                  [value]="sg.advertisementCategoryId">
                        {{ categoryDisplayName(sg.advertisementCategoryId)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="row m-0">
                <div class="col-md-4">
                  <mat-form-field class="full-width">
                    <input matInput
                           type="text"
                           placeholder="{{!isThirdPartyAd ? 'Your Nick' : 'Your business name'}}"
                           formControlName="nick"
                           required />
                    <mat-error *ngIf="advForm.controls['nick'].hasError('nick')">
                      Nick is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-3 d-flex p-0" *ngIf="!isThirdPartyAd">
                  <div class="col p-0">
                    <mat-form-field class="full-width">
                      <input matInput
                            type="number"
                            placeholder="Age"
                            formControlName="age" />
                    </mat-form-field>
                  </div>
                  <div class="col p-0">
                    <mat-form-field class="full-width">
                      <mat-select required placeholder="State"
                                  formControlName="region"
                                  (selectionChange)="setSelectedRegion($event.value)">
                        <mat-option>
                          <ngx-mat-select-search [placeholderLabel]="'ex. Washington'"
                                                [noEntriesFoundLabel]="'No matching found'"
                                                [formControl]="regionFilter"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let r of filteredRegions"
                                    [value]="r.regionId">
                          {{ r.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="advForm.controls['region'].hasError('region')">
                        State is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-3 pr-0" *ngIf="!isThirdPartyAd">
                  <mat-form-field class="full-width" [hidden]="!advForm.controls.region.value">
                    <mat-select required placeholder="City"
                                (selectionChange)="onChangesSelect($event)"
                                formControlName="subregion">
                      <mat-option>
                        <ngx-mat-select-search [placeholderLabel]="'ex. Newport'"
                                               [noEntriesFoundLabel]="'No matching found'"
                                               [formControl]="subregionFilter"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let r of filteredSubregion"
                                  [value]="r.subRegionId">
                        {{ r.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="
                        advForm.controls['subregion'].hasError('subregion')
                      ">
                      City is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col" *ngIf="!isThirdPartyAd">
                  <mat-form-field class="full-width">
                    <input matInput
                           type="text"
                           placeholder="Zip code"
                           formControlName="postalCode"
                           required />
                    <mat-error *ngIf="
                        advForm.controls['postalCode'].hasError('postalCode')
                      ">
                      Zip code is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row m-0 position-relative">
                <div class="col-md-12">
                  <mat-form-field class="full-width">
                    <input #titleInput
                           matInput
                           (blur)="titleBlur($event)"
                           maxlength="255"
                           type="text"
                           placeholder="Ad Title"
                           formControlName="title"
                           required
                           (click)="titleClick($event)" />
                    <mat-error *ngIf="advForm.controls['title'].hasError('title')">
                      Ad Title is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="d-flex emoji-container">
                  <emoji-picker (change)="updateTitle($event)"
                                [text]="advForm.controls['title'].value"
                                [element]="titleInput"
                                *ngIf="isPremiumFunctionality || isThirdPartyAd">
                  </emoji-picker>
                </div>
              </div>

              <div class="row m-0 position-relative">
                <div class="col-md-12">
                  <mat-form-field class="w-100">
                    <textarea #descriptionInput
                              maxlength="8192"
                              (blur)="descriptionBlur($event)"
                              cdkTextareaAutosize
                              cdkAutosizeMinRows="12"
                              cdkAutosizeMaxRows="16"
                              matInput
                              placeholder="Description"
                              formControlName="content"
                              required
                              style="height: 180px;">
                    </textarea>
                    <mat-error *ngIf="advForm.controls['content'].hasError('required')">
                      Content is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="d-flex emoji-container">
                  <emoji-picker (change)="updateContent($event)"
                                [text]="advForm.controls['content'].value"
                                [element]="descriptionInput"
                                *ngIf="isPremiumFunctionality || isThirdPartyAd">
                  </emoji-picker>
                </div>
              </div>
              <div class="row m-0 p-0" *ngIf="Expired && AdType==1 && !SpecialUser && !HasUserPremiumAdToken && !isThirdPartyAd">
                <premium-ad-token-payment></premium-ad-token-payment>
              </div>
              <div class="row m-0 p-0" *ngIf="Expired && isThirdPartyAd && !HasUserThirdPartyAdToken">
                <premium-ad-token-payment [payButtonText]="'Pay $99 for Third Party Ad Now'" [paymentFormType]="2"></premium-ad-token-payment>
              </div>
              
            </mat-card-content>

            <mat-card-actions class="m-0">
              <div class="row m-0">
                <div class="col-md-12">
                  <div class="row m-0 pb-4 align-items-center">
                    <div class="col-md-6 pl-0 d-flex">
                      <div class="">
                        <mat-checkbox formControlName="termAccepted"
                                      (change)="termsAcceptAction($event)"></mat-checkbox>
                      </div>
                      <div class="pl-2 pr-2">
                        <mat-card-subtitle>
                          * Your ad will expire after 2 weeks. By posting an ad
                          on WickedList.com you agree to be bound by our
                          <a href="https://wickedlist.com/b/terms-of-use/" target="_blank">Terms And Conditions</a> and our
                          <a href="https://wickedlist.com/b/privacy-policy/" target="_blank">Privacy Policy</a>
                        </mat-card-subtitle>
                      </div>
                    </div>
                    <div class="col-md-6 pr-0 d-flex">
                      <re-captcha (resolved)="captchaResolved($event)"
                                  *ngIf="this.captchaAvailable()"
                                  size="200px"
                                  [siteKey]="this.captchaService.getCurrentCaptchaKey()">
                      </re-captcha>
                      <span *ngIf="!this.captchaAvailable()">
                        For use captcha, you should configure captcha site key
                        properly
                      </span>
                    </div>
                    <div class="col-md-7 pl-0 pr-0">
                      <button *ngIf="!Expired"
                              class=" m-0 mt-4 p-2 px-5 submit-button"
                              mat-flat-button 
                              color="primary"
                              [disabled]="submitInProgress || termsNotAccepted || !this._captchaResolvedFlag"
                              type="submit">
                        <span>
                          {{
                      this.submitInProgress ? "Submitting" : "Submit"
                          }}
                        </span>
                      </button>

                      <button *ngIf="Expired"
                              class="m-0 p-2 px-5 submit-button"
                              mat-flat-button 
                              color="primary"
                              [disabled]="submitInProgress || termsNotAccepted"
                              type="submit">
                        <span *ngIf="Expired && AdType==1 && !SpecialUser"><span *ngIf="!HasUserPremiumAdToken">Pay 1.99$ & </span>Re-List</span>
                        <span *ngIf="Expired && ((AdType==0 && !SpecialUser) || SpecialUser)">Re-List</span>
                      </button>
                    </div>
                    <div class="col-md-7 pl-0 pr-0" *ngIf="false">
                      <mat-checkbox formControlName="publish">Publish</mat-checkbox>
                    </div>
                  </div>
                </div>
              </div>             
            </mat-card-actions>
          </mat-card>
        </div>
        <div class="col-lg-4 col-md-12 pl-0 pr-0 pt-2">
          <mat-card class="pt-0 pr-0">
            <div mat-card-image
                 *ngIf="selectedImage"
                 class="w-100 _h-100 selected-image-holder m-0"
                 [style.backgroundImage]="'url(' + selectedImage.imageUrl + '/800x600)'"></div>
            <div mat-card-image
                 *ngIf="!selectedImage"
                 class="w-100 h-100 selected-image-holder placeholder-image m-0"></div>
            <div style="min-height:200px"
                 mat-card-image
                 *ngIf="!selectedImage"
                 class="w-100 h-100 selected-image-holder placeholder-image m-0"></div>
          </mat-card>

          <mat-card class="adv-card mt-0 pr-0">
            <mat-card-content>
              <div class="row m-0">
                <div class="files-area col-md-12">

                  <div class="choose-file p-0" *ngIf="!isMaxImagesExeeded()">
                    <input id="singleFile"
                            type="file"
                            accept="image/x-png,image/gif,image/jpeg"
                            [uploadInputFor]="This" />
                  </div>
                  <div *ngIf="!isMaxImagesExeeded()"
                       class="w-100 pt-5 pb-5 drag-col text-right"
                       cdkDropList
                       (cdkDropListEntered)="entered($event)"
                       (cdkDropListEntered)="entered($event)"
                       (cdkDropListDropped)="drop($event)">
                    Or drag picture(s) here ...
                  </div>
                </div>
                <mat-card-subtitle class="mt-2">
                  <b style="color:black;">Nude or explicit photos will be removed </b>
                  <a href="/b/terms-of-use/" target="_blank">Terms and Conditions</a>
                </mat-card-subtitle>
                <mat-card _cdkDrag
                          (mouseover)="overAction(i)"
                          (cdkDragStarted)="cdkDragStarted($event, childItem, i)"
                          (cdkDragReleased)="cdkDragReleased($event, i)"
                          *ngFor="let img of images; let i = index"
                          (click)="selectedImage = img"
                          [ngClass]="{ selected: selectedImage == img }"
                          class="mat-uploaded-image w-45 mr-1 mb-1">
                  <button mat-mini-fab
                          color="glb_pinkbtn"
                          (click)="deleteImage(img)"
                          class="del-img-icon">
                    <mat-icon>delete_outline</mat-icon>
                  </button>

                  <mat-card-content>
                    <div mat-card-image
                         class="mat-card-base mt-1"
                         [style.backgroundImage]="'url(' + img.imageUrl + '/350x200)'"></div>
                    <div style="width: 100%; height:20px; overflow: hidden;text-align: center; display:none">
                      {{ img.orgFileName }}
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </form>
  </div>
</div>
